import { RequirementConfig } from "../../core/_models/requirement-config.model";

export const TemperatureTrackingNumberConfig: RequirementConfig = {
  "summaryLabel": "No. of tracking devices :",
  "question": "How many tracking devices?",
};
